import React, { useState } from "react";
import { FaStar, FaQuoteRight, FaArrowLeft, FaArrowRight } from "react-icons/fa";

function HappyCustomersSection() {
  const testimonials = [
    {
      name: "Harvey Specter",
      title: "DESIGNER",
      quote:
        "This is a truly spectacular theme! The custom page builder is definitely one of the most intuitive and user-friendly page builders I’ve ever used.",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
      iconColor: "bg-green-500"
    },
    {
      name: "Bruce Wayne",
      title: "DESIGNER",
      quote:
        "This is a truly spectacular theme! The custom page builder is definitely one of the most intuitive and user-friendly page builders I’ve ever used.",
      image: "https://randomuser.me/api/portraits/men/22.jpg",
      iconColor: "bg-orange-500"
    },
    {
      name: "Rachel Zane",
      title: "DESIGNER",
      quote:
        "Amazing theme with great flexibility and easy-to-use page builder. Highly recommend it!",
      image: "https://randomuser.me/api/portraits/women/12.jpg",
      iconColor: "bg-pink-500"
    },
    {
      name: "Mike Ross",
      title: "DEVELOPER",
      quote:
        "User-friendly and highly customizable. Made our project look professional with minimal effort.",
      image: "https://randomuser.me/api/portraits/men/35.jpg",
      iconColor: "bg-purple-500"
    },
    {
      name: "Donna Paulsen",
      title: "DESIGNER",
      quote:
        "Beautiful design and intuitive interface. Highly recommend this for any business.",
      image: "https://randomuser.me/api/portraits/women/50.jpg",
      iconColor: "bg-yellow-500"
    }
  ];

  const [startIndex, setStartIndex] = useState(0);

  const visibleCards = 3;

  const nextSlide = () => {
    setStartIndex((prev) =>
      prev + visibleCards >= testimonials.length ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setStartIndex((prev) =>
      prev === 0 ? testimonials.length - visibleCards : prev - 1
    );
  };

  const getVisibleTestimonials = () => {
    const endIndex = startIndex + visibleCards;
    if (endIndex <= testimonials.length) {
      return testimonials.slice(startIndex, endIndex);
    }
    return [
      ...testimonials.slice(startIndex),
      ...testimonials.slice(0, endIndex - testimonials.length)
    ];
  };

  return (
    <section className="py-16 bg-white relative">
      <div className="container mx-auto px-4">
        <h2 className="text-center text-4xl font-bold mb-4 text-gray-900">
          Our Happy Customers
        </h2>
        <p className="text-center max-w-2xl mx-auto text-gray-600 mb-12">
          Marketing experts in your niche with proven ROI results, backed by
          unbiased monitoring. Consistent unbiased monitoring to assure optimal
          results and accountability
        </p>

        <div className="relative flex items-center justify-center">
          {/* Left Arrow */}
          <button
            onClick={prevSlide}
            className="absolute left-0 bg-white border border-customcolor text-black px-3 py-2 hover:bg-customcolor hover:text-white transition rounded-none"
          >
            <FaArrowLeft />
          </button>

          {/* Testimonials Grid */}
          <div className="flex gap-6 overflow-hidden">
            {getVisibleTestimonials().map((testimonial, index) => (
              <div
                key={index}
                className="flex flex-col items-center p-8 bg-white shadow-md rounded-lg text-center w-80"
              >
                <div className="relative mb-6">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-24 h-24 rounded-full mx-auto object-cover"
                  />
                  <div
                    className={`w-8 h-8 ${testimonial.iconColor} rounded-full flex items-center justify-center absolute right-[calc(50%-40px)] bottom-0 translate-x-1/2`}
                  >
                    <FaQuoteRight className="text-white text-sm" />
                  </div>
                </div>
                <p className="text-gray-700 text-base mb-4">
                  {testimonial.quote}
                </p>
                <div className="flex justify-center mb-4">
                  {[...Array(4)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-400 mr-1" />
                  ))}
                  <FaStar className="text-yellow-400 mr-1 transform scale-x-75" />
                </div>
                <h5 className="text-lg font-semibold text-gray-900">
                  {testimonial.name}
                </h5>
                <p className="text-xs text-gray-500 mt-1">{testimonial.title}</p>
              </div>
            ))}
          </div>

          {/* Right Arrow */}
          <button
            onClick={nextSlide}
            className="absolute right-0 bg-white border border-customcolor text-black px-3 py-2 hover:bg-customcolor hover:text-white transition rounded-none"
          >
            <FaArrowRight />
          </button>
        </div>
      </div>
    </section>
  );
}

export default HappyCustomersSection;
